module.exports = __webpack_public_path__ + "static/media/10.e8b59853.JPG";